import { render, staticRenderFns } from "./Template30.vue?vue&type=template&id=07b080e6&scoped=true&"
import script from "./Template30.vue?vue&type=script&lang=js&"
export * from "./Template30.vue?vue&type=script&lang=js&"
import style0 from "./Template30.vue?vue&type=style&index=0&id=07b080e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07b080e6",
  null
  
)

export default component.exports